import React from 'react';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './animatedSvgLogo.css';

const svgsInfo = [
  {
    id: 1,
    top: '20%',
    left: '32%',
    size: 17,
    opacity: 0.7,
    animationDelay: '0s',
  },
  {
    id: 2,
    top: '43%',
    left: '25%',
    size: 20,
    opacity: 0.6,
    animationDelay: '0.7s',
  },
  {
    id: 3,
    top: '34%',
    left: '14%',
    size: 13,
    opacity: 0.8,
    animationDelay: '0.4s',
  },
  {
    id: 4,
    top: '68%',
    left: '19%',
    size: 13,
    opacity: 0.5,
    animationDelay: '0.6s',
  },
  {
    id: 5,
    top: '12%',
    right: '24%',
    size: 30,
    opacity: 0.7,
    animationDelay: '0.1s',
  },
  {
    id: 6,
    top: '28%',
    right: '17%',
    size: 10,
    opacity: 0.6,
    animationDelay: '1s',
  },
  {
    id: 7,
    top: '49%',
    right: '22%',
    size: 17,
    opacity: 0.75,
    animationDelay: '1.2s',
  },
  {
    id: 8,
    top: '68%',
    right: '12%',
    size: 10,
    opacity: 0.6,
    animationDelay: '0.5s',
  },
];

const svgUI = {
  [VIDABOO_CONSTANTS.ANIMATED_SVG_LOGO_TYPES.MESSENGER]: {
    ui: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 64 64"
        fill="none">
        <rect
          width="64"
          height="64"
          rx="32"
          fill="url(#paint0_linear_5743_14131)"
          fillOpacity="0.1"
        />
        <path
          d="M19.4 44.8V52L26 48.2C27.8 48.8 29.8 49 32 49C43 49 52 40.8 52 30.4C52 20.2 43 12 32 12C21 12 12 20.2 12 30.6C12 36.4 14.8 41.4 19.4 44.8Z"
          stroke="url(#paint1_linear_5743_14131)"
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.6 26.4L23 35.4L30.4 33.6L33.4 35.4L41 26.4L34 28.2L30.6 26.4Z"
          stroke="url(#paint2_linear_5743_14131)"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_5743_14131"
            x1="50.9091"
            y1="-5.09091"
            x2="16"
            y2="66.1818"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#E06F62" />
            <stop offset="0.5" stopColor="#9B3CDD" />
            <stop offset="1" stopColor="#6281FB" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_5743_14131"
            x1="32"
            y1="12"
            x2="32"
            y2="52"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#DF656D" />
            <stop offset="0.245" stopColor="#BE49AC" />
            <stop offset="0.605" stopColor="#CE4F93" />
            <stop offset="0.825" stopColor="#637DFA" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_5743_14131"
            x1="32"
            y1="26.4"
            x2="32"
            y2="35.4"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#DF656D" />
            <stop offset="0.245" stopColor="#BE49AC" />
            <stop offset="0.605" stopColor="#CE4F93" />
            <stop offset="0.825" stopColor="#637DFA" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  [VIDABOO_CONSTANTS.ANIMATED_SVG_LOGO_TYPES.WHATSAPP]: {
    ui: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 64 64"
        fill="none">
        <rect width={64} height={64} fill="#78CD51" fillOpacity={0.1} rx={32} />
        <path
          stroke="#78CD51"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          strokeWidth={1.745}
          d="M24.582 44.51c2.182 1.309 4.8 2.036 7.419 2.036 8 0 14.545-6.545 14.545-14.545s-6.545-14.546-14.545-14.546-14.546 6.546-14.546 14.546c0 2.618.727 5.09 1.891 7.272l-1.25 4.809a1.455 1.455 0 0 0 1.807 1.765l4.68-1.337Z"
        />
        <path
          stroke="#78CD51"
          strokeMiterlimit={10}
          strokeWidth={1.455}
          d="M38.546 36.144c0 .235-.053.478-.164.713a2.7 2.7 0 0 1-.446.668 2.955 2.955 0 0 1-1.075.772c-.393.164-.82.249-1.278.249-.669 0-1.383-.157-2.137-.478a11.524 11.524 0 0 1-2.255-1.296 18.837 18.837 0 0 1-2.15-1.833 18.601 18.601 0 0 1-1.83-2.14 11.665 11.665 0 0 1-1.284-2.232c-.315-.746-.472-1.46-.472-2.14 0-.445.079-.87.236-1.264.157-.399.407-.765.754-1.093.42-.412.878-.615 1.363-.615.184 0 .367.04.531.118.17.078.322.196.44.366l1.52 2.14c.118.164.204.315.263.459.059.137.091.275.091.4a.888.888 0 0 1-.137.464c-.085.15-.21.308-.367.465l-.498.517a.35.35 0 0 0-.105.262c0 .052.006.098.02.15.019.053.039.092.052.131.118.216.32.497.61.838.294.34.609.687.95 1.034.354.347.695.668 1.042.962.341.288.623.485.846.602l.118.053c.052.02.105.026.164.026a.36.36 0 0 0 .268-.111l.499-.491a2.01 2.01 0 0 1 .472-.367.873.873 0 0 1 .465-.137c.125 0 .256.026.4.085.144.059.295.144.459.255l2.17 1.538c.17.118.288.256.36.42.066.163.105.327.105.51Z"
        />
      </svg>
    ),
  },
  [VIDABOO_CONSTANTS.ANIMATED_SVG_LOGO_TYPES.PHONE_CALL]: {
    ui: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 64 64"
        fill="none">
        <rect width={64} height={64} fill="#2961FA" fillOpacity={0.1} rx={32} />
        <path
          stroke="#2D2756"
          strokeMiterlimit={10}
          strokeWidth={1.745}
          d="M46.502 41.208c0 .523-.116 1.062-.363 1.585a6.004 6.004 0 0 1-.99 1.484c-.712.785-1.498 1.353-2.385 1.716a7.305 7.305 0 0 1-2.836.553c-1.484 0-3.07-.35-4.742-1.062-1.673-.713-3.346-1.673-5.004-2.88a41.816 41.816 0 0 1-4.77-4.073 41.325 41.325 0 0 1-4.059-4.756c-1.193-1.658-2.152-3.316-2.85-4.96-.699-1.658-1.048-3.244-1.048-4.756 0-.99.175-1.935.524-2.808.349-.887.902-1.701 1.672-2.429.931-.916 1.95-1.367 3.026-1.367.407 0 .814.087 1.178.262.378.174.713.436.975.814l3.374 4.757c.262.363.451.698.582 1.018.13.305.204.61.204.887 0 .35-.102.698-.306 1.033-.189.335-.465.684-.814 1.033l-1.106 1.149a.778.778 0 0 0-.233.582c0 .116.015.218.044.334.044.116.087.204.116.291.262.48.713 1.106 1.353 1.862a49.683 49.683 0 0 0 2.11 2.298c.785.771 1.541 1.484 2.312 2.138.756.64 1.382 1.077 1.876 1.338.073.03.16.073.262.117.117.043.233.058.364.058a.8.8 0 0 0 .596-.247l1.106-1.091c.363-.364.712-.64 1.047-.815.334-.203.669-.305 1.033-.305.276 0 .567.058.887.189.32.13.654.32 1.018.567l4.815 3.418c.378.262.64.568.8.931.145.364.232.727.232 1.135Z"
        />
      </svg>
    ),
  },
  [VIDABOO_CONSTANTS.ANIMATED_SVG_LOGO_TYPES.CUSTOM_LINK]: {
    ui: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        fill="none">
        <path
          stroke={'var(--et-mentor-cta-btn-primary-background-color-fc)'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          strokeWidth={1.2}
          d="M14.99 17.5h1.51c3.02 0 5.5-2.47 5.5-5.5 0-3.02-2.47-5.5-5.5-5.5h-1.51M9 6.5H7.5A5.51 5.51 0 0 0 2 12c0 3.02 2.47 5.5 5.5 5.5H9M8 12h8"
        />
      </svg>
    ),
  },
};

const AnimatedSvgLogo = ({type}) => {
  return (
    <div className="et-v2-animated-svg-logo-container">
      <div
        className={`et-v2-asl-centered-svg ${type === VIDABOO_CONSTANTS.ANIMATED_SVG_LOGO_TYPES.CUSTOM_LINK ? 'et-v2-asl-centered-svg-custom-link' : ''}`}>
        {svgUI[type].ui}
      </div>
      {svgsInfo.map((svgIcon) => (
        <div
          key={svgIcon.id}
          className={`et-v2-asl-moving-svg ${type === VIDABOO_CONSTANTS.ANIMATED_SVG_LOGO_TYPES.CUSTOM_LINK ? 'et-v2-asl-moving-svg-custom-link' : ''}`}
          style={{
            height: `${svgIcon.size}px`,
            top: svgIcon.top,
            left: svgIcon.left,
            right: svgIcon.right,
            opacity: svgIcon.opacity,
            animationDelay: svgIcon.animationDelay,
          }}>
          {svgUI[type].ui}
        </div>
      ))}
    </div>
  );
};

export default AnimatedSvgLogo;
